import * as Yup from 'yup';

const initialValues = () => ({
  allergiesToggle: '',
  allergies: '',
  conditionsToggle: '',
  conditions: '',
  medicationsToggle: '',
  medications: [],
  doctors: [],
});

const schema = Yup.object().shape({
  allergiesToggle: Yup.string().required('Please select an option'),
  allergies: Yup.mixed().when('allergiesToggle', {
    is: 'Yes',
    then: Yup.string().required('Please list any allergies or select “No” above.'),
    otherwise: Yup.mixed().notRequired(),
  }),
  conditionsToggle: Yup.string().required('Please select an option'),
  conditions: Yup.mixed().when('conditionsToggle', {
    is: 'Yes',
    then: Yup.string().required('Please list any medical conditions or select “No” above.'),
    otherwise: Yup.mixed().notRequired(),
  }),
  medicationsToggle: Yup.string().required('Please select an option'),
  medications: Yup.array().when('medicationsToggle', {
    is: 'Yes',
    then: Yup.array().of(Yup.string().required('Please list any other medications or select “No” above.')),
    otherwise: Yup.array().of(Yup.string().notRequired()),
  }),
  doctors: Yup.array().of(Yup.string()),
});

const validation = {
  initialValues,
  schema,
};

export default validation;
